import { render, staticRenderFns } from "./ModalError.vue?vue&type=template&id=71e28f84&"
import script from "./ModalError.vue?vue&type=script&lang=js&"
export * from "./ModalError.vue?vue&type=script&lang=js&"
import style0 from "./ModalError.vue?vue&type=style&index=0&id=71e28f84&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports